import React, { useCallback, useEffect, useState } from "react";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import vendor from "../../assets/svg/cardVendor.svg";
import "./Dashboard.css";
import PurchaseIc from "../../assets/svg/purchase_ic.svg";
import ProductIc from "../../assets/svg/product_ic.svg";
import ProductOrderIc from "../../assets/svg/purchaseOrder_ic.svg";
import ConfrimOrder from "../../assets/svg/confirm_order_ic.svg";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  PointElement,
  LinearScale,
  LineElement,
  Filler,
  BarElement,
} from "chart.js";
import {
  getAmountAnalysApi,
  getCountApi,
  getCountryBasedOverviewApi,
  getPaymentOverviewApi,
  getPaymentTypeOverApi,
  getPendingPaymentApi,
  getPoPaymentApi,
  getPoStatusApi,
  getProductApi,
  getProductSpendApi,
  getProjectBasedOverApi,
  getProjectStageDetailsApi,
  getStageApi,
  getStateBasedOverviewApi,
  getTransOverViewApi,
  getVendorAnalysApi,
  getVendorApi,
  getVendorBasedOverApi,
  getVendorDetailsApi,
  getVendorSpendApi,
} from "./dasboard_api";
import moment from "moment/moment";
import DateRangeFilter from "../filterDatepicker";
import numberFormat from "../common/number-format";
import { useNavigate } from "react-router-dom";
import { PaymentsOverviewRow } from "./PaymentsOverviewRow.jsx";
import { CompletionCardsRow } from "./CompletionCardsRow.jsx";
import { TransactionsChart } from "./TransactionsChart.jsx";
import { AnalyticsCardsRow } from "./AnalyticsCardsRow.jsx";
import { SpendAnalyticsRow } from "./SpendAnalyticsRow.jsx";
import { PaymentProjectRow } from "./PaymentProjectRow.jsx";
import { VendorAndPendingOverviewRow } from "./VendorAndPendingOverviewRow.jsx";
import { CountryBasedOverviewRow } from "./CountryBasedOverviewRow.jsx";
import { VendorPaymentAnalysisTable } from "./VendorPaymentAnalysisTable.jsx";
import { ProjectStageAnalysisTable } from "./ProjectStageAnalysisTable.jsx";
ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Filler,
  Tooltip,
  Legend,
);

export const DashboardPage = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const navigate = useNavigate();
  const [selectedProductYear, setSelectedProductYear] = useState(null);
  const [selectedPendingYear, setSelectedPendingYear] = useState(null);
  const [selectedVendorYear, setSelectedVendorYear] = useState(null);
  const [selectedTransMonth, setSelectedTransMonth] = useState(null);
  const [selectedTransQuarterly, setSelectedTransQuarterly] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [vendorOption, setVendorOption] = useState(null);
  const [productOption, setProductOption] = useState(null);
  const [projectOption, setProjectOption] = useState(null);
  const [countryOption, setCountryOption] = useState({
    label: "India",
    value: "1",
  });
  const [activeView, setActiveView] = useState("Daily");
  const [countDetails, setCountDetails] = useState({});
  const [vendorAnaDetails, setVendorAnaDetails] = useState([]);
  const [vendorActive, setVendorActive] = useState(0);
  const [vendorInActive, setVendorInActive] = useState(0);
  const [amountAnaDetails, setAmountAnaDetails] = useState({});
  const [poPayemntDetails, setPoPaymentDetails] = useState({});
  const [poStatusDetails, setPoStatusDetails] = useState({});
  const [vendorStDetails, setVendorStDetails] = useState({});
  const [vendorStVaDetails, setVendorStVaDetails] = useState({});
  const [paymentTypeDetails, setPaymentTypeDetails] = useState([]);
  const [projectOverviewDetails, setProjectOverviewDetails] = useState([]);
  const [paymentOverviewDetails, setPaymentOverviewDetails] = useState({});
  const [productStDetails, setProductStDetails] = useState({});
  const [productStValDetails, setProductStValDetails] = useState({});
  const [activeMonthIndex, setActiveMonthIndex] = useState(0);
  const [transOverDetails, setTransOverDetails] = useState([]);
  const [pageVendorCount, setPageVendorCount] = useState(0);
  const [vendorOffset, setVendorOffset] = useState(0);
  const [vendorPerPage, setVendorPerPage] = useState(10);
  const [pageProjectCount, setPageProjectCount] = useState(0);
  const [projectOffset, setProjectOffset] = useState(0);
  const [projectPerPage, setProjectPerPage] = useState(10);
  const [vendorList, setVendorList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [stageList, setStageList] = useState([]);

  const [activeProjectTab, setActiveProjectTab] = useState(null);

  const formattedFromDate = dateRange[0]
    ? moment(dateRange[0]).format("YYYY-MM-DD")
    : "";
  const formattedToDate = dateRange[1]
    ? moment(dateRange[1]).format("YYYY-MM-DD")
    : "";
  const [activeTab, setActiveTab] = useState("Top");
  const [paymentTypeTab, setPaymentTypeTab] = useState("Country");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const [countriesData, setCountriesData] = useState([]);
  const [vendorsData, setVendorsData] = useState([]);
  const [pendingData, setPendingData] = useState([]);

  const topColors = (Array.isArray(vendorStDetails?.labels) ? vendorStDetails.labels : []).map((_, i) => {
    return i === activeMonthIndex ? "#3B5BDB" : "rgba(59,91,219,0.15)";
  });

  const bottomColors = (Array.isArray(vendorStDetails?.labels) ? vendorStDetails.labels : []).map((_, i) => {
    return i === activeMonthIndex ? "#3B5BDB" : "rgba(59,91,219,0.15)";
  });
  const handlePageClick = useCallback((event) => {
    setVendorOffset(event.selected);
  }, []);
  const handlePageProjectClick = useCallback((event) => {
    setProjectOffset(event.selected);
  }, []);
  const amountDataArray = [
    { label: "Paid", value: amountAnaDetails.paid ?? 0, color: "#5EC493" },
    {
      label: "Pending",
      value: amountAnaDetails.pending ?? 0,
      color: "#F44336",
    },
  ];
  const verticalLinePlugin = {
    id: "verticalLineIndicator",
    afterDraw(chart) {
      if (!chart.tooltip?._active?.length) return;

      const ctx = chart.ctx;
      const activePoint = chart.tooltip._active[0];

      const x = activePoint.element.x;
      const top = chart.chartArea.top;
      const bottom = chart.chartArea.bottom;

      ctx.save();

      ctx.setLineDash([4, 4]); // 👈 dotted line (dash, gap)
      ctx.lineDashOffset = 0;

      ctx.beginPath();
      ctx.moveTo(x, top);
      ctx.lineTo(x, bottom);
      ctx.lineWidth = 1.5;
      ctx.strokeStyle = "#64748B"; // 👈 required color
      ctx.stroke();

      ctx.restore();
    },
  };

  const paymentTypeData = {
    labels: paymentTypeDetails.map((item) => item.payment_type),
    datasets: [
      {
        label: "Payments",
        data: paymentTypeDetails.map((item) => item.amount),
        backgroundColor: "#DBD9FF",
        hoverBackgroundColor: "#4F46E5",
        barThickness: 23,
        minBarLength: 10,
        borderRadius: {
          topRight: 999,
          bottomRight: 999,
          topLeft: 0,
          bottomLeft: 0,
        },
      },
    ],
  };

  const paymentTypeOptions = {
    indexAxis: "y",

    plugins: {
      legend: false,

      tooltip: {
        backgroundColor: "#FFFFFF",
        titleColor: "#8790A1",
        bodyColor: "#172B4D",
        padding: 12,
        cornerRadius: 8,
        displayColors: false,
        callbacks: {
          // title: (items) => items[0].label,
          label: (item) => [`Amount: ₹${item.raw}`, `Count: ${12}`],
        },
      },
    },

    scales: {
      y: {
        ticks: {
          align: "start", // ← Align all labels left
          color: (context) => {
            return "#626F86"; // default color for others
          },
          hoverColor: (context) => {
            return "#4F46E5"; // default color for others
          },
          font: {
            weight: "10px",
          },
        },
        grid: { display: false },
      },

      x: {
        grid: { color: "#eee" },
        // ticks: { color: "#666" },
        position: "bottom",
        ticks: {
          color: "#6E6E6E",
          font: { size: 11 },
          callback: (value) => formatIndianNumber(value),
        },
      },
    },
  };

  // ======================= OVERDUE – LINE CHART =======================
  const overdueData = {
    labels: pendingData.map((item) => item.period_label),
    datasets: [
      {
        label: "Pending Amount",
        data: pendingData.map((item) => item.pending_amount),
        borderColor: "#4F46E5",
        pointBackgroundColor: "#4F46E5", // 👈 fill color
        borderWidth: 2,
        tension: 0.0,
        pointRadius: 0,
        borderDash: [6, 6],
      },
    ],
  };

  const overdueOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },

    plugins: {
      legend: {
        display: false,
      },

      tooltip: {
        enabled: false, // disable default tooltip
        intersect: false,
        mode: "index",

        external: function (context) {
          // CUSTOM COMMON TOOLTIP
          const { chart, tooltip } = context;
          let tooltipEl = document.getElementById("multi-tooltip");

          // Create tooltip element if missing
          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "multi-tooltip";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.background = "#FFFFFF";
            tooltipEl.style.border = "1px solid #E5E7EB";
            tooltipEl.style.borderRadius = "10px";
            tooltipEl.style.padding = "12px 16px";
            tooltipEl.style.boxShadow = "0px 4px 20px rgba(0,0,0,0.12)";
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.zIndex = "9999";
            document.body.appendChild(tooltipEl);
          }

          // Hide if no tooltip
          if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          // Build tooltip content
          let html = `<div style="font-size:13px; color:#4F46E5; margin-bottom:6px;">
                        ${tooltip.title[0]}
                    </div>`;

          tooltip.dataPoints.forEach((dp) => {
            const color = dp.dataset.borderColor;
            const name = dp.dataset.label;
            const value = "₹" + dp.raw.toLocaleString("en-IN");

            html += `
    <div style="
        display:flex;
        align-items:center;
        justify-content:space-between;
        margin-bottom:6px;
        gap:12px;
        width:100%;
    ">
        <div style="display:flex; align-items:center; gap:6px;">

            <span style="color:#111827; font-size:13px;">${name}</span>
        </div>

        <div style="font-weight:600; color:#111827; font-size:13px; white-space:nowrap;">
            ${value}
        </div>
    </div>
  `;
          });

          tooltipEl.innerHTML = html;

          // Position tooltip
          const canvas = chart.canvas;
          const rect = canvas.getBoundingClientRect();
          const tooltipWidth = tooltipEl.offsetWidth;

          tooltipEl.style.opacity = 1;
          tooltipEl.style.left =
            rect.left +
            window.scrollX +
            tooltip.caretX -
            tooltipWidth -
            20 +
            "px";
          tooltipEl.style.top =
            rect.top + window.scrollY + tooltip.caretY - 20 + "px";
        },
      },
    },

    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#9FA6B2",
          font: { size: 12 },
        },
      },

      y: {
        type: "linear",
        beginAtZero: true,
        border: {
          display: true,
          dash: [5, 5], // ⭐ finally dotted
          color: "#D7DFE4",
          width: 1.2,
        },
        grid: {
          display: true,
          drawOnChartArea: true, // ⭐ required for showing dashed lines
          drawTicks: false,
          drawBorder: false,
          color: "#E5E7EB", // line color
          borderDash: [4, 4], // ⭐ dotted lines
          borderDashOffset: 2,
          lineWidth: 1,
        },

        ticks: {
          color: "#6E6E6E",
          font: { size: 11 },
          callback: (value) => formatIndianNumber(value),
        },
      },
    },
  };

  const optionsForBar = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false, // disable default tooltip
        mode: "index",
        intersect: false,
        external: function (context) {
          let tooltipEl = document.getElementById("chartjs-tooltip");

          // Create tooltip container if not exists
          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-tooltip";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.background = "#fff";
            tooltipEl.style.border = "1px solid #E0E0E0";
            tooltipEl.style.borderRadius = "8px";
            tooltipEl.style.boxShadow = "0px 2px 6px rgba(0,0,0,0.1)";
            tooltipEl.style.padding = "8px 12px";
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.transition = "all .1s ease";
            document.body.appendChild(tooltipEl);
          }

          const tooltipModel = context.tooltip;

          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          if (tooltipModel.body) {
            const title = tooltipModel.title[0];
            const bodyLines = tooltipModel.dataPoints;

            let innerHtml = `
            <div style="font-weight:600; color:#3B5BDB; margin-bottom:6px;">
              ${title} 2025
            </div>
          `;

            bodyLines.forEach((bodyItem) => {
              const dataset = bodyItem.dataset;
              const color = dataset.backgroundColor;
              const label = dataset.label;
              const value = bodyItem.raw;

              innerHtml += `
              <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:4px;">
                <div style="display:flex; align-items:center; gap:6px;">
                  <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:${color};"></span>
                  <span style="font-size:13px; color:#555;">${label}</span>
                </div>
         <div style={{ fontWeight: 600, color: "#000" }}>
  ${label === "Spent" ? "₹" : ""}
  ${numberFormat(value, 2)}
</div>

              </div>
            `;
            });

            tooltipEl.innerHTML = innerHtml;
          }

          // Position tooltip
          const { offsetLeft: positionX, offsetTop: positionY } =
            context.chart.canvas;
          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = positionX + tooltipModel.caretX + "px";
          tooltipEl.style.top = positionY + tooltipModel.caretY + "px";
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: true, // show vertical grid lines
          drawTicks: false, // hide ticks if needed
          drawBorder: false, // hide axis line
          color: "#E0E0E0", // line color
          borderDash: [4, 4], // dotted line pattern: 4px dash, 4px gap
        },
        ticks: {
          maxTicksLimit: 5, // only 5 vertical labels
          color: "#7D7D7D",
          font: { size: 12 },
          borderDash: [4, 4],
        },
      },
      y: {
        beginAtZero: true,
        ticks: { maxTicksLimit: 5, borderDash: [4, 4] },
        grid: {
          color: "#E0E0E0", // horizontal grid color
        },
      },
    },
  };
  const optionsForProjectBar = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: { display: false },

      tooltip: {
        enabled: false, // disable default tooltip
        mode: "index",
        intersect: false,

        external: function (context) {
          let tooltipEl = document.getElementById("chartjs-project-tooltip");

          // Create tooltip container if not exists
          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-project-tooltip";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.background = "#fff";
            tooltipEl.style.border = "1px solid #E0E0E0";
            tooltipEl.style.borderRadius = "8px";
            tooltipEl.style.boxShadow = "0px 2px 6px rgba(0,0,0,0.1)";
            tooltipEl.style.padding = "8px 12px";
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.transition = "all .1s ease";
            document.body.appendChild(tooltipEl);
          }

          const tooltipModel = context.tooltip;

          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          if (tooltipModel.body) {
            const title = tooltipModel.title[0];
            const bodyLines = tooltipModel.dataPoints;

            let innerHtml = `
            <div style="font-weight:600; color:#3B5BDB; margin-bottom:6px;">
              ${title}
            </div>
          `;

            bodyLines.forEach((bodyItem) => {
              const dataset = bodyItem.dataset;
              const color = Array.isArray(dataset.backgroundColor)
                ? dataset.backgroundColor[bodyItem.dataIndex]
                : dataset.backgroundColor;

              const label = dataset.label;
              const value = bodyItem.raw;

              const formattedValue = Number(Math.abs(value)).toLocaleString(
                "en-IN",
                {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                },
              );

              innerHtml += `
  <div style="
    display:grid;
    grid-template-columns: 1fr auto;
    align-items:center;
    margin-bottom:4px;
    min-width:220px;
    column-gap:20px;
  ">
    <div style="display:flex; align-items:center; gap:6px;">
      <span style="width:8px; height:8px; border-radius:50%; background:${color};"></span>
      <span style="font-size:13px; color:#555;">${label}</span>
    </div>

    <div style="font-weight:600; color:#000;">
      ${label === "Budget Spent" ? "₹" : ""}${formattedValue}
    </div>
  </div>
`;
            });

            tooltipEl.innerHTML = innerHtml;
          }

          // Position tooltip
          const { offsetLeft: positionX, offsetTop: positionY } =
            context.chart.canvas;

          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = positionX + tooltipModel.caretX + "px";
          tooltipEl.style.top = positionY + tooltipModel.caretY + "px";
        },
      },
    },

    scales: {
      x: {
        grid: {
          display: true,
          drawTicks: false,
          drawBorder: false,
          color: "#E0E0E0",
          borderDash: [4, 4],
        },
        ticks: {
          maxRotation: 45,
          minRotation: 45,
          autoSkip: false,
          maxTicksLimit: 5,
          color: "#7D7D7D",
          font: { size: 12 },
        },
      },

      y: {
        beginAtZero: true,
        ticks: {
          maxTicksLimit: 5,
        },
        grid: {
          color: "#E0E0E0",
        },
        ticks: {
          color: "#6E6E6E",
          font: { size: 11 },
          callback: (value) => formatIndianNumber(value),
        },
      },
    },
  };

  const optionsForVendor = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    onClick: (evt, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index; // get clicked bar index
        setActiveMonthIndex(index);
      }
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: "#7D7D7D",
          font: { size: 12 },
        },
        stacked: true,
      },
      y: {
        stacked: true,
        grid: { display: false },
        ticks: { display: false },
        grace: "1%",
      },
    },
  };

  const createGradient = (ctx) => {
    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, "#C3BFFF");
    gradient.addColorStop(1, "#FFFFFF00");
    return gradient;
  };
  const formatIndianNumber = (num) => {
    if (num >= 10000000)
      return (num / 10000000).toFixed(1).replace(/\.0$/, "") + "Cr"; // Crore
    if (num >= 100000)
      return (num / 100000).toFixed(1).replace(/\.0$/, "") + "L"; // Lakh
    if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K"; // Thousand
    return num.toString(); // below 1000 → show as is
  };

  const optionsForTransaction = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        mode: "index",
        intersect: false,
        callbacks: {
          label: function (context) {
            return "₹" + context.parsed.y.toLocaleString();
          },
          title: function (context) {
            return context[0].label + " 2025"; // Adds year to month
          },
        },
        backgroundColor: "#fff",
        titleColor: "#6366f1", // ← Changed to blue
        bodyColor: "#000",
        borderColor: "#e5e7eb", // ← Lighter border
        borderWidth: 1,
        padding: 16, // ← Increased padding
        displayColors: false,
        titleFont: {
          size: 13, // ← Slightly smaller
          weight: "500", // ← Medium weight
        },
        bodyFont: {
          size: 24, // ← Larger for amount
          weight: "bold",
        },
        titleMarginBottom: 8, // ← Spacing between title and amount
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // ← Shadow (may not work in all versions)
        cornerRadius: 8, // ← Rounded corners
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          color: "#999",
          font: {
            size: 12,
          },
        },
      },
      y: {
        grid: {
          color: "rgba(0, 0, 0, 0.05)",
          drawBorder: false,
        },
        border: {
          display: false,
          dash: [5, 5],
        },
        ticks: {
          color: "#999",
          font: {
            size: 12,
          },
          callback: function (value) {
            if (value >= 1000) return value / 1000 + "K";
            return value;
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
  };

  const buttonStyle = (view) => ({
    padding: "8px 20px",
    border: "none",
    backgroundColor: activeView === view ? "#6366f1" : "transparent",
    color: activeView === view ? "#fff" : "#666",
    cursor: "pointer",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: activeView === view ? "600" : "500",
    transition: "all 0.2s ease",
    marginRight: "5px",
  });

  const orderOptions = {
    cutout: "80%",
    plugins: { legend: { display: false } },
  };

  const options = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };

  const dataForBar = {
    labels: productStDetails.period ?? [],
    datasets: [
      {
        label: "Spent",
        data: productStDetails.amount ?? [],
        backgroundColor: "#3B5BDB", // Blue
        borderRadius: 8,
        barThickness: 8,
      },
      {
        label: "Products",
        data: productStDetails.product ?? [],
        backgroundColor: "#FD7E14", // Orange
        borderRadius: 8,
        barThickness: 8,
        minBarLength: 8,
      },
    ],
  };
  const dataForVendor = {
    labels: Array.isArray(vendorStDetails?.labels) ? vendorStDetails.labels : [],
    datasets: [
      {
        label: "Top",
        data: Array.isArray(vendorStDetails?.data) ? vendorStDetails.data.map((v) => v) : [],
        backgroundColor: topColors,
        borderRadius: 20,
        barThickness: 18,
        stack: "combined",
      },
      {
        label: "Bottom",
        data: Array.isArray(vendorStDetails?.data) ? vendorStDetails.data.map((v) => -v) : [],
        backgroundColor: bottomColors,
        borderRadius: 20,
        barThickness: 18,
        stack: "combined",
      },
    ],
  };
  const safeProjectOverviewDetails = Array.isArray(projectOverviewDetails) ? projectOverviewDetails : [];
  const dataForProject = {
    labels: safeProjectOverviewDetails.map((item) => item.project_name), // static periods
    datasets: [
      {
        label: "Project Cost",
        data: safeProjectOverviewDetails.map((item) => item.project_cost ?? 0),
        backgroundColor: "#4F46E5", // Blue
        borderRadius: 8,
        barThickness: 8,
        minBarLength: 8, // ✅ minimum bar length
      },
      {
        label: "Spent Amount",
        data: safeProjectOverviewDetails.map((item) => item.spent_amount ?? 0),
        backgroundColor: "#DCDAFF", // Orange
        borderRadius: 8,
        barThickness: 8,
        minBarLength: 8,
      },
    ],
  };

  const chartData = {
    labels: transOverDetails.labels,
    datasets: [
      {
        label: "Transactions",
        data: transOverDetails.data,
        borderColor: "rgb(99, 102, 241)",
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) {
            return null;
          }
          return createGradient(ctx);
        },
        fill: true,
        tension: 0.1,
        pointRadius: 0,
        pointHoverRadius: 6,
        pointHoverBackgroundColor: "rgb(99, 102, 241)",
        pointHoverBorderColor: "#fff",
        pointHoverBorderWidth: 2,
      },
    ],
  };

  const data = {
    labels: amountDataArray.map((item) => item.label),
    datasets: [
      {
        data: amountDataArray.map((item) => item.value),
        backgroundColor: amountDataArray.map((item) => item.color),
        borderWidth: 0,
        cutout: "80%", // inner cut
        circumference: 180, // half circle
        rotation: 270, // start from left
        borderRadius: 10,
      },
    ],
  };

  const requestData = {
    labels: ["Pending", "Completed"],
    datasets: [
      {
        data: [poPayemntDetails.Pending ?? 0, poPayemntDetails.Completed ?? 0],
        backgroundColor: ["#4F46E5", "#F34F81"],
        borderWidth: 0,
      },
    ],
  };

  const requestOptions = {
    plugins: {
      legend: { display: false },
    },
  };

  const orderData = {
    labels: ["Draft", "Confirmed", "Cancelled"],
    datasets: [
      {
        data: [
          poStatusDetails.Draft ?? 0,
          poStatusDetails.Confirmed ?? 0,
          poStatusDetails.Cancelled ?? 0,
        ],
        backgroundColor: ["#4F46E5", "#F34F81", "#70B944"],
        borderWidth: 0,
      },
    ],
  };
  const getCountDetails = async () => {
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
    };
    try {
      const response = await getCountApi(params);
      console.log("response", response);
      if (response.success === true) {
        setCountDetails(response.data ?? {});
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getVendorAnalDetails = async () => {
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
    };
    try {
      const response = await getVendorAnalysApi(params);
      console.log("response", response);
      if (response.success === true) {
        setVendorAnaDetails(response.data ?? {});
        setVendorActive(response?.active ?? 0);
        setVendorInActive(response?.inactive ?? 0);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getPaymentTypeDetails = async () => {
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
    };
    try {
      const response = await getPaymentTypeOverApi(params);
      console.log("response", response);
      if (response.success === true) {
        setPaymentTypeDetails(response.data ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getProjectOverViewDetails = async () => {
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
    };
    try {
      const response = await getProjectBasedOverApi(params);
      console.log("response", response);
      if (response.success === true) {
        setProjectOverviewDetails(response.data ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getPaymentOverviewDetails = async () => {
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
    };
    try {
      const response = await getPaymentOverviewApi(params);
      console.log("response", response);
      if (response.success === true) {
        setPaymentOverviewDetails(response.data ?? {});
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getVendorBasedOverviewDetails = async () => {
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
      type: activeTab,
    };
    try {
      const response = await getVendorBasedOverApi(params);
      console.log("response", response);
      if (response.success === true) {
        setVendorsData(response.data ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getCountryBasedDetails = async () => {
    if (paymentTypeTab !== "Country") return;
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
    };
    try {
      const response = await getCountryBasedOverviewApi(params);
      console.log("response", response);
      if (response.success === true) {
        setCountriesData(response.data ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getStateBasedDetails = async () => {
    if (paymentTypeTab !== "State") return;
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
      country_id: countryOption?.value ?? "",
    };
    try {
      const response = await getStateBasedOverviewApi(params);
      console.log("response", response);
      if (response.success === true) {
        setCountriesData(response.data ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getVendorOverDetails = async () => {
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
      limit: vendorPerPage,
      skip: vendorOffset * vendorPerPage,
    };
    try {
      const response = await getVendorDetailsApi(params);
      console.log("response", response);
      if (response.success === true) {
        setPageVendorCount(response.total_pgs ?? 0);
        setVendorList(response.vendors ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getProjectStageOverDetails = async () => {
    if (activeProjectTab === null) return;
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
      limit: projectPerPage,
      skip: projectOffset * projectPerPage,
      stage_id: activeProjectTab,
    };
    try {
      const response = await getProjectStageDetailsApi(params);
      console.log("response", response);
      if (response.success === true) {
        setPageProjectCount(response.total_pgs ?? 0);
        setProjectList(response.projects ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getStageList = async () => {
    try {
      const response = await getStageApi();
      console.log("response", response);
      if (response.success === true) {
        setStageList(response.data ?? []);
        if (response.data.length > 0) {
          setActiveProjectTab(response.data[0]?.value ?? "");
        }
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getPendingPaymentDetails = async () => {
    const params = {
      year: moment(selectedPendingYear).format("YYYY"),
    };
    try {
      const response = await getPendingPaymentApi(params);
      console.log("response", response);
      if (response.success === true) {
        setPendingData(response.data ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getAmountAnalDetails = async () => {
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
    };
    try {
      const response = await getAmountAnalysApi(params);
      console.log("response", response);
      if (response.success === true) {
        setAmountAnaDetails(response.data ?? {});
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getPoPaymentDetails = async () => {
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
    };
    try {
      const response = await getPoPaymentApi(params);
      console.log("response", response);
      if (response.success === true) {
        setPoPaymentDetails(response.data ?? {});
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getPoStatusDetails = async () => {
    const params = {
      from_date: formattedFromDate,
      to_date: formattedToDate,
    };
    try {
      const response = await getPoStatusApi(params);
      console.log("response", response);
      if (response.success === true) {
        setPoStatusDetails(response.data ?? {});
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getVendorSpenDetails = async () => {
    if (!vendorOption?.value) return;
    const bodyData = {
      vendor_id: vendorOption.value,
      period: moment(selectedVendorYear).format("YYYY"),
    };
    try {
      const response = await getVendorSpendApi(bodyData);
      console.log("response", response);
      if (response.success === true) {
        setVendorStVaDetails(response.data ?? {});
        const apiData = response.data.chart ?? [];

        const chartData = {
          labels: apiData.map((item) => item.period),
          data: apiData.map((item) => Number(item.amount)),
        };
        setVendorStDetails(chartData);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getProductSpenDetails = async () => {
    if (!productOption?.value) return;
    const bodyData = {
      product_id: productOption.value,
      project_id: projectOption?.value ?? "",
      period: moment(selectedProductYear).format("YYYY"),
    };
    try {
      const response = await getProductSpendApi(bodyData);
      console.log("response", response);
      if (response.success === true) {
        setProductStValDetails(response.data ?? {});
        const responseData = response.data.chart ?? [];
        const chartData = {
          amount: responseData.map((item) => Number(item.amount) || 0),
          product: responseData.map((item) => item.pcs ?? 0),
          period: responseData.map((item) => item.period ?? ""),
        };

        setProductStDetails(chartData);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  const handleDateRangeChange = (range) => {
    setDateRange(range);
  };

  const getVendorList = async () => {
    try {
      const response = await getVendorApi();
      if (response.success === true) {
        const suggestions = response.suggestionlist ?? [];
        if (suggestions.length > 0) {
          setVendorOption(suggestions[0]);
        } else {
          setVendorOption(null);
        }
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getProductList = async () => {
    try {
      const response = await getProductApi();
      if (response.success === true) {
        const suggestions = response.suggestionlist ?? [];
        if (suggestions.length > 0) {
          setProductOption(suggestions[0]);
        } else {
          setProductOption(null);
        }
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  useEffect(() => {
    const currentDate = new Date();

    console.log("currentDate", currentDate);

    setSelectedProductYear(currentDate);
    setSelectedPendingYear(currentDate);
    setSelectedVendorYear(currentDate);
    setSelectedTransMonth(currentDate);
    setSelectedTransQuarterly(currentDate);

    getVendorList();
    getProductList();
    getStageList();
  }, []);

  useEffect(() => {
    getCountDetails();
    getVendorAnalDetails();
    getAmountAnalDetails();
    getPaymentTypeDetails();
    getProjectOverViewDetails();
    getPoPaymentDetails();
    getPoStatusDetails();
    getPaymentOverviewDetails();
  }, [dateRange]);
  useEffect(() => {
    getVendorOverDetails();
  }, [dateRange, vendorPerPage, vendorOffset]);
  useEffect(() => {
    getProjectStageOverDetails();
  }, [dateRange, projectPerPage, projectOffset, activeProjectTab]);
  useEffect(() => {
    getVendorBasedOverviewDetails();
  }, [dateRange, activeTab]);
  useEffect(() => {
    getCountryBasedDetails();
  }, [dateRange, paymentTypeTab]);
  useEffect(() => {
    getStateBasedDetails();
  }, [dateRange, countryOption, paymentTypeTab]);
  useEffect(() => {
    if (selectedPendingYear) {
      getPendingPaymentDetails();
    }
  }, [selectedPendingYear]);

  useEffect(() => {
    getVendorSpenDetails();
  }, [vendorOption, selectedVendorYear]);

  useEffect(() => {
    getProductSpenDetails();
  }, [selectedProductYear, projectOption, productOption]);

  return (
    <div>
      <div className="d-flex">
        <Sidebar currentfile="Dashboard" />
        <div className="rounded-4 flex-grow-1">
          <div className="" style={{ backgroundColor: "#F5F8FA" }}>
            <Navbar pageTitle="Dashboard" />
            <div className="p-3">
              <div
                className="d-flex justify-content-between align-items-center mb-2"
                style={{ width: "100%" }}
              >
                <p className="fs-24 fw-700 mb-0">Dashboard</p>
                <div style={{ flexShrink: 0 }}>
                  <DateRangeFilter
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                    onChange={handleDateRangeChange}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <div
                    className="bg-white rounded-4 p-3 pe-4 cursor-pointer"
                    onClick={() => {
                      navigate("/vendor");
                    }}
                  >
                    <div className="d-flex gap-3">
                      <img src={vendor} alt="vendor" />
                      <div className="d-flex flex-column">
                        <p className="m-0 cardTextGrey fs-13 fw-400">Vendors</p>
                        <p className="m-0 fs-24 fw-500">
                          {countDetails.vendors ?? 0}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div
                    className="bg-white rounded-4 p-3 pe-4 cursor-pointer"
                    onClick={() => {
                      navigate("/product");
                    }}
                  >
                    <div className="d-flex gap-3">
                      {" "}
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "40px",
                          backgroundColor: "#F4F4F4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img src={ProductIc} alt="vendor" />
                      </div>
                      <div className="d-flex flex-column">
                        <p className="m-0 cardTextGrey fs-13 fw-400">
                          Products
                        </p>
                        <p className="m-0 fs-24 fw-500">
                          {" "}
                          {countDetails.products ?? 0}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div
                    className="bg-white rounded-4  p-3 pe-4 cursor-pointer"
                    onClick={() => {
                      navigate("/transaction");
                    }}
                  >
                    <div className="d-flex gap-3">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "40px",
                          backgroundColor: "#F4F4F4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img src={PurchaseIc} alt="" />
                      </div>

                      <div className="d-flex flex-column">
                        <p
                          className="m-0 text-truncate cardTextGrey fs-13 fw-400"
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "150px", // adjust width as needed
                          }}
                        >
                          Purchase Transactions
                        </p>
                        <p className="m-0 fs-24 fw-500">
                          {" "}
                          {countDetails.purchase_trans ?? 0}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div
                    className="bg-white rounded-4  p-3 pe-4 cursor-pointer"
                    onClick={() => {
                      navigate("/purchase-order");
                    }}
                  >
                    <div className="d-flex gap-3">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "40px",
                          backgroundColor: "#F4F4F4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img src={ProductOrderIc} alt="" />
                      </div>

                      <div className="d-flex flex-column">
                        <p
                          className="m-0 cardTextGrey fs-13 fw-400"
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "150px", // adjust width as needed
                          }}
                        >
                          Purchase Orders
                        </p>
                        <p className="m-0 fs-24 fw-500">
                          {" "}
                          {countDetails.purchase_order ?? 0}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div
                    className="bg-white rounded-4  p-3 pe-4 cursor-pointer"
                    onClick={() => {
                      navigate("/purchase-order", {
                        state: {
                          status: "Confirmed",
                        },
                      });
                    }}
                  >
                    <div className="d-flex gap-3">
                      {" "}
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "40px",
                          backgroundColor: "#F4F4F4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img src={ConfrimOrder} alt="" />
                      </div>
                      <div className="d-flex flex-column">
                        <p
                          className="m-0 cardTextGrey fs-13 fw-400"
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "150px", // adjust width as needed
                          }}
                        >
                          Confirm Order
                        </p>
                        <p className="m-0 fs-24 fw-500">
                          {" "}
                          {countDetails.comfirm_order ?? 0}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <PaymentsOverviewRow />
              <CompletionCardsRow />
              <div className="row mt-3">
                <div className="col-xl-12">
                  <TransactionsChart />
                </div>
              </div>

              {/* Payment Rate Cards Row */}
              <div className="payment-rate-grid mt-3">
                <div className="payment-rate-card" style={{ border: '1px solid #F1F3F9' }}>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#212129', fontFamily: "'Lexend Deca', sans-serif" }}>
                    Payments completion rate (%)
                  </span>
                  <span style={{ fontSize: '24px', fontWeight: '600', color: '#62C18A', fontFamily: "'Lexend Deca', sans-serif" }}>
                    {Math.round(paymentOverviewDetails.payment_completion_rate ?? 0)}%
                  </span>
                </div>
                <div className="payment-rate-card" style={{ border: '1px solid #F1F3F9' }}>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#212129', fontFamily: "'Lexend Deca', sans-serif" }}>
                    Payments pending rate (%)
                  </span>
                  <span style={{ fontSize: '24px', fontWeight: '600', color: '#62C18A', fontFamily: "'Lexend Deca', sans-serif" }}>
                    {Math.round(paymentOverviewDetails.payment_pending_rate ?? 0)}%
                  </span>
                </div>
                <div className="payment-rate-card" style={{ border: '1px solid #F1F3F9' }}>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#212129', fontFamily: "'Lexend Deca', sans-serif" }}>
                    Payments overdue rate (%)
                  </span>
                  <span style={{ fontSize: '24px', fontWeight: '600', color: '#62C18A', fontFamily: "'Lexend Deca', sans-serif" }}>
                    {Math.round(Math.max(0, 100 - (Number(paymentOverviewDetails.payment_completion_rate ?? 0) + Number(paymentOverviewDetails.payment_pending_rate ?? 0))))}%
                  </span>
                </div>
              </div>

              <PaymentProjectRow
                paymentTypeDetails={paymentTypeDetails}
                projectOverviewDetails={projectOverviewDetails}
              />
              <AnalyticsCardsRow
                vendorActive={vendorActive}
                vendorInActive={vendorInActive}
                vendorAnaDetails={vendorAnaDetails}
                poPayemntDetails={poPayemntDetails}
                poStatusDetails={poStatusDetails}
                amountAnaDetails={amountAnaDetails}
              />

              <SpendAnalyticsRow
                apiUrl={apiUrl}
                productOption={productOption}
                setProductOption={setProductOption}
                projectOption={projectOption}
                setProjectOption={setProjectOption}
                selectedProductYear={selectedProductYear}
                setSelectedProductYear={setSelectedProductYear}
                productStValDetails={productStValDetails}
                productStDetails={productStDetails}
                selectedVendorYear={selectedVendorYear}
                setSelectedVendorYear={setSelectedVendorYear}
                vendorOption={vendorOption}
                setVendorOption={setVendorOption}
                vendorStDetails={vendorStDetails}
                vendorStVaDetails={vendorStVaDetails}
                activeMonthIndex={activeMonthIndex}
                setActiveMonthIndex={setActiveMonthIndex}
              />

              <VendorAndPendingOverviewRow
                vendorsData={vendorsData}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                selectedPendingYear={selectedPendingYear}
                setSelectedPendingYear={setSelectedPendingYear}
                pendingData={pendingData}
              />

              <CountryBasedOverviewRow
                paymentTypeTab={paymentTypeTab}
                setPaymentTypeTab={setPaymentTypeTab}
                countryOption={countryOption}
                setCountryOption={setCountryOption}
                countriesData={countriesData}
                apiAdminUrl={apiAdminUrl}
              />

              <VendorPaymentAnalysisTable
                vendorList={vendorList}
                hoveredIndex={hoveredIndex}
                setHoveredIndex={setHoveredIndex}
                vendorPerPage={vendorPerPage}
                setVendorPerPage={setVendorPerPage}
                pageVendorCount={pageVendorCount}
                handlePageClick={handlePageClick}
              />

              <ProjectStageAnalysisTable
                stageList={stageList}
                activeProjectTab={activeProjectTab}
                setActiveProjectTab={setActiveProjectTab}
                projectList={projectList}
                hoveredIndex={hoveredIndex}
                setHoveredIndex={setHoveredIndex}
                projectPerPage={projectPerPage}
                setProjectPerPage={setProjectPerPage}
                pageProjectCount={pageProjectCount}
                handlePageProjectClick={handlePageProjectClick}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
